import api from "./api";

export const verifyTurnstile = (token) =>
  api.post("/security/verify-turnstile", {
    token,
  });